<template>
  <div>
    <hamburger-component :count="filtersCount" @click="openPanel"/>
    <transition name="fade">
      <settings-panel
        v-if="isPanelActive"
        :type="mode"
        @close="closePanel"
        @switch="toggleMode"
        @filters="openFilters"
      />
    </transition>
    <transition name="fade">
      <filters-component v-if="areFiltersOpen" @close="closeFilters"/>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { TOGGLE_MODE } from '@/store/mutation-types'

import HamburgerComponent from '@/components/Hamburger'
import SettingsPanel from '@/containers/Settings/SettingsPanel'
import FiltersComponent from '@/containers/Settings/Filters'

export default {
  components: {
    HamburgerComponent,
    SettingsPanel,
    FiltersComponent
  },
  data () {
    return {
      isPanelActive: false,
      areFiltersOpen: false
    }
  },
  computed: {
    ...mapGetters(['filtersCount', 'mode'])
  },
  methods: {
    ...mapMutations({ toggleMode: TOGGLE_MODE }),
    openPanel () {
      this.isPanelActive = true
    },
    closePanel () {
      this.isPanelActive = false
    },
    openFilters () {
      this.areFiltersOpen = true
    },
    closeFilters () {
      this.areFiltersOpen = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Settings/SettingsContainer.vue